export default __webpack_public_path__ + "static/media/icaew_logo.db63746d.svg";